import React, { createElement } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import authorized from '../../authorized';

export const SecureRoute = (
  { component, render, user, permissions, ...rest }
) => (
  <Route
    {...rest}
    render={props =>
      authorized({ user, permissions })
        ? render ? render(props) : createElement(component, props)
        : <Redirect
            to={{
              pathname: '/login',
              from: props.location,
              permissions
            }}
          />}
  />
);

const mapState = state => ({ user: state.login.toJS().result });
export default connect(mapState)(SecureRoute);



// WEBPACK FOOTER //
// ./src/components/ui/SecureRoute.js